import React from 'react';
import styles from './SaveSubtitlesModal.module.scss';
import { useTranslation } from 'react-i18next';
import Modal from '../../../../components/Modal';
import { CustomButton } from '../../../../components/Button/Button';
import { Icon } from '../../../../components/Icon';

const SaveSubtitlesModal = ({ open, onClose, onConfirm }) => {
  const { t } = useTranslation();
  return (
    <Modal open={open} onClose={onClose} closeIcon={close}>
      <div className={styles.modalWrapper}>
        <div className={styles.headerContainer}>
          <h2 className={styles.header}>{t('subtitles.editor.correct_text_header')}</h2>
          <CustomButton onClick={onClose} className={styles.closeBtn} variant="link" ariaLabel={t('general.close')}>
            <Icon src="close" className={styles.closeIcon} />
          </CustomButton>
        </div>
        <p className={styles.text}>{t('subtitles.editor.correct_warning')}</p>
        <div className={styles.btnContainer}>
          <CustomButton variant="secondary" label={t('subtitles.editor.back_button')} onClick={onClose} className={styles.cancelBtn} />
          <CustomButton variant="primary" label={t('subtitles.editor.continue_button')} onClick={onConfirm} />
        </div>
      </div>
    </Modal>
  );
};

export default SaveSubtitlesModal;
